module.exports = __webpack_public_path__ + "img/hall_5.f1b8dc45.jpg";